<template>
  <v-layout row align-center justify-space-around>
    <v-flex style="flex:none" color="grey lighten-2" class="accent--text elevation-0 pointerClass" v-if="counters.indexOf('tweets') > -1" @click="goToPage('/tweets')">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading">repeat</v-icon> Tweets</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{tweetsLoading === true ? '-' : formatNumber(tweetsCount)}}</div>
      </v-card-title>
    </v-flex>
    
    <v-flex @click="goToPage('/users')" style="flex:none" color="grey lighten-2" class="accent--text elevation-0 pointerClass" v-if="counters.indexOf('users') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading">person</v-icon> Users</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{usersLoading === true ? '-' : formatNumber(usersCount)}}</div>
      </v-card-title>
    </v-flex>

    <v-flex @click="goToPage('/hashtags')" style="flex:none" color="grey lighten-2" class="accent--text elevation-0 pointerClass" v-if="counters.indexOf('hashtags') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon style="font-size: 14px;line-height: 17px;">fas fa-hashtag</v-icon> Hashtags</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{hashtagsLoading === true ? '-' : formatNumber(hashtagsCount)}}</div>
      </v-card-title>
    </v-flex>
    
    <v-flex style="flex:none"  color="grey lighten-2" class="accent--text elevation-0" v-if="counters.indexOf('impressions') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading">volume_up</v-icon> Impressions</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{impressionsLoading === true ? '-' : formatNumber(impressionsCount)}}</div>
      </v-card-title>
    </v-flex>
    
    <v-flex @click="goToPage('/articles')" style="flex:none" color="grey lighten-2" class="accent--text elevation-0 pointerClass" v-if="counters.indexOf('articles') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading">fa-newspaper</v-icon> Articles</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{articlesLoading === true ? '-' : formatNumber(articlesCount)}}</div>
      </v-card-title>
    </v-flex>
    
    <v-flex style="flex:none" color="grey lighten-2" class="accent--text elevation-0" v-if="counters.indexOf('countries') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading">location_on</v-icon> Countries</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{countriesLoading === true ? '-' : formatNumber(countriesCount)}}</div>
      </v-card-title>
    </v-flex>

    <v-flex @click="goToPage('/sources')" style="flex:none" color="grey lighten-2" class="accent--text elevation-0 pointerClass" v-if="counters.indexOf('sources') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading pr-1">language</v-icon>Sources</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{domainsLoading === true ? '-' : formatNumber(domainsCount)}}</div>
      </v-card-title>
    </v-flex>
    
    <v-flex @click="goToPage('/stories')" style="flex:none" color="grey lighten-2" class="accent--text elevation-0 pointerClass" v-if="counters.indexOf('stories') > -1">
      <v-card-title primary-title class='pb-0'>
        <div class="body-1"><v-icon class="subheading pr-1">fa-comments</v-icon>Stories</div>
      </v-card-title>
      <v-card-title primary-title class='pt-0 justify-center'>
        <div class="display-1">{{storiesLoading === true ? '-' : formatNumber(storiesCount)}}</div>
      </v-card-title>
    </v-flex>
  </v-layout>
</template>
<style>
  .pointerClass{cursor: pointer;}
</style>
<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import numeral from 'numeral'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    counters: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      tweetsLoading: false,
      usersLoading: false,
      hashtagsLoading: false,
      impressionsLoading: false,
      articlesLoading: false,
      countriesLoading: false,
      domainsLoading: false,
      storiesLoading: false,
      countriesCount: 0,
      articlesCount: 0,
      impressionsCount: 0,
      usersCount: 0,
      hashtagsCount: 0,
      tweetsCount: 0,
      domainsCount: 0,
      storiesCount: 0
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    goToPage: function (page) {
      this.$router.push({ path: page, query: this.$route.query })
    },
    getData: function () {
      if (this.counters.indexOf('tweets') > -1) {
        this.tweetsLoading = true
        axios.all([
          this.$store.dispatch('getTweetsCount', this.getQuery({}))
        ]).then(axios.spread((r1) => {
          if (r1.data.status === 'SUCCESS') {
            this.tweetsCount = Number(r1.data.payload[0]._tweet_count)
            if (isNaN(this.tweetsCount)) {
              this.tweetsCount = 0
            }
            this.tweetsLoading = false
          } else {
            this.tweetsLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.tweetsLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('users') > -1) {
        this.usersLoading = true
        axios.all([
          this.$store.dispatch('getUsersCount', this.getQuery({}))
        ]).then(axios.spread((r2) => {
          if (r2.data.status === 'SUCCESS') {
            this.usersCount = Number(r2.data.payload[0]._user_count)
            if (isNaN(this.usersCount)) {
              this.usersCount = 0
            }
            this.usersLoading = false
          } else {
            this.usersLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.usersLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('hashtags') > -1) {
        this.hashtagsLoading = true
        axios.all([
          this.$store.dispatch('getHashtagsCount', this.getQuery({}))
        ]).then(axios.spread((r2) => {
          if (r2.data.status === 'SUCCESS') {
            this.hashtagsCount = Number(r2.data.payload[0]._hashtag_count)
            if (isNaN(this.hashtagsCount)) {
              this.hashtagsCount = 0
            }
            this.hashtagsLoading = false
          } else {
            this.hashtagsLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.hashtagsLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('impressions') > -1) {
        this.impressionsLoading = true
        axios.all([
          this.$store.dispatch('getImpressionsCount', this.getQuery({}))
        ]).then(axios.spread((r3) => {
          if (r3.data.status === 'SUCCESS') {
            this.impressionsCount = Number(r3.data.payload[0]._impression_count)
            if (isNaN(this.impressionsCount)) {
              this.impressionsCount = 0
            }
            this.impressionsLoading = false
          } else {
            this.impressionsLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.impressionsLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('articles') > -1) {
        this.articlesLoading = true
        axios.all([
          this.$store.dispatch('getArticlesCount', this.getQuery({}))
        ]).then(axios.spread((r4) => {
          if (r4.data.status === 'SUCCESS') {
            this.articlesCount = Number(r4.data.payload[0]._article_count)
            if (isNaN(this.articlesCount)) {
              this.articlesCount = 0
            }
            this.articlesLoading = false
          } else {
            this.articlesLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.articlesLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('countries') > -1) {
        this.countriesLoading = true
        axios.all([
          this.$store.dispatch('getTwitterCountriesCount', this.getQuery({}))
        ]).then(axios.spread((r5) => {
          if (r5.data.status === 'SUCCESS') {
            this.countriesCount = Number(r5.data.payload[0]._country_count)
            if (isNaN(this.countriesCount)) {
              this.countriesCount = 0
            }
            this.countriesLoading = false
          } else {
            this.countriesLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.countriesLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('sources') > -1) {
        this.domainsLoading = true
        axios.all([
          this.$store.dispatch('getDomainsCount', this.getQuery({}))
        ]).then(axios.spread((r6) => {
          if (r6.data.status === 'SUCCESS') {
            this.domainsCount = Number(r6.data.payload[0]._domain_count)
            if (isNaN(this.domainsCount)) {
              this.domainsCount = 0
            }
            this.domainsLoading = false
          } else {
            this.domainsLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.domainsLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
      if (this.counters.indexOf('stories') > -1) {
        this.storiesLoading = true
        axios.all([
          this.$store.dispatch('getStoriesCount', this.getQuery({}))
        ]).then(axios.spread((r7) => {
          if (r7.data.status === 'SUCCESS') {
            this.storiesCount = Number(r7.data.payload[0]._story_count)
            if (isNaN(this.storiesCount)) {
              this.storiesCount = 0
            }
            this.storiesLoading = false
          } else {
            this.storiesLoading = false
            this.notify({message: 'Something went wrong while fetching data.', show: true})
          }
        })).catch((err) => {
          this.storiesLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (!underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Counters.vue